import React from "react";

const Goals = () => {
  const goals = [
    "دعم الابتكار وريادة الأعمال",
    "تمكين المرأة والشباب في مختلف المجالات",
    "تعزيز مفهوم التنمية المستدامة في المجتمع",
    "بناء شراكات محلية ودولية لتحقيق أهداف التنمية المستدامة",
    "تحسين جودة الحياة ومكافحة الفقر",
  ];

  return (
    <section className="goals-section">
      <div className="goals-container">
        <h2 className="section-title"> أهدافنا</h2>
        <div className="underline"></div>

        <div className="goals-grid">
          {goals.map((goal, index) => (
            <div key={index} className="goal-card">
              <div className="goal-icon">
                <span>✓</span>
              </div>
              <p>{goal}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .goals-section {
          background: linear-gradient(to bottom right, #f5f9ff, #e7efff);
          padding: 100px 20px;
          text-align: center;
          direction: rtl;
          position: relative;
          overflow: hidden;
        }

        /* ديكوريشن الخلفية */
        .goals-section::before {
          content: '';
          position: absolute;
          width: 220px;
          height: 220px;
          top: -60px;
          left: -60px;
          background: rgba(0, 74, 173, 0.15);
          border-radius: 50%;
          filter: blur(40px);
        }

        .goals-section::after {
          content: '';
          position: absolute;
          width: 180px;
          height: 180px;
          bottom: -40px;
          right: -40px;
          background: rgba(0, 74, 173, 0.12);
          border-radius: 50%;
          filter: blur(35px);
        }

        .section-title {
          font-size: 2.3rem;
          color: #004aad;
          font-weight: 800;
          margin-bottom: 10px;
          position: relative;
          z-index: 2;
        }

        .underline {
          width: 100px;
          height: 4px;
          background: #004aad;
          margin: 0 auto 50px auto;
          border-radius: 2px;
        }

        .goals-container {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 3;
        }

        .goals-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 25px;
        }

        .goal-card {
          background: white;
          border-radius: 16px;
          padding: 25px;
          box-shadow: 0 6px 18px rgba(0, 74, 173, 0.08);
          display: flex;
          align-items: center;
          gap: 15px;
          transition: all 0.3s ease;
          text-align: right;
        }

        .goal-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 10px 24px rgba(0, 74, 173, 0.15);
        }

        .goal-icon {
          background: #004aad;
          color: white;
          font-size: 1.2rem;
          font-weight: bold;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .goal-card p {
          font-size: 1.05rem;
          color: #333;
          margin: 0;
          line-height: 1.7;
          text-align: right;
        }

        /* ✅ رسبونسيف */
        @media (max-width: 768px) {
          .section-title {
            font-size: 1.9rem;
          }

          .goals-grid {
            gap: 20px;
          }

          .goal-card {
            padding: 20px;
          }

          .goal-card p {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .section-title {
            font-size: 1.7rem;
          }

          .underline {
            width: 80px;
            height: 3px;
            margin-bottom: 30px;
          }

          .goal-icon {
            width: 32px;
            height: 32px;
            font-size: 1rem;
          }
        }
      `}</style>
    </section>
  );
};

export default Goals;
